<script>
import { validationMixin } from 'vuelidate'
import { fieldValidationsMixin } from '@/mixins/fieldValidationsMixin'
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AvvComponent',
  mixins: [validationMixin, fieldValidationsMixin],
  props: {
    hideTitle: Boolean,
    hideSubmit: Boolean,
    setAvvCheckbox: {
      type: Boolean,
      default: true
    }
  },
  data: (vm) => ({
    alwaysAcceptAVV: vm.$props.setAvvCheckbox,
    // alwaysAcceptAVV: true,
    confirmed: false,
    submitError: false,
    loading: false
  }),
  validations: {
    alwaysAcceptAVV: {
      required,
      checked(val) {
        return val
      }
    }
  },
  computed: {
    ...mapGetters(['hasAVV'])
  },
  methods: {
    ...mapActions(['saveAlwaysAcceptAVV']),
    changeEvent(value) {
      this.$emit('update:alwaysAcceptAVV', value)
      this.$v.alwaysAcceptAVV.$touch()
    },
    submitAVV() {
      return new Promise(async (resolve, reject) => {
        this.$v.$touch()
        this.submitError = false
        if (this.$v.$invalid) {
          this.submitError = true
          this.$notify(this.$t('component.profile.accountManagement.avv.error'), {
            type: 'error'
          })
          reject(false)
          return
        }
        this.loading = true
        try {
          await this.saveAlwaysAcceptAVV()
          this.confirmed = true
          resolve(true)
        } catch {
          this.confirmed = false
          this.submitError = true
          this.$notify(this.$t('component.profile.accountManagement.avv.error'), {
            type: 'error'
          })
          reject(false)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
<template>
  <div v-show="!hasAVV && !confirmed">
    <div v-if="!hideTitle">
      <v-icon color="warning">mdi-information</v-icon>
      <span
      ><slot name="title">{{ $t('component.profile.accountManagement.accept.avv') }}</slot></span>
    </div>
    <v-checkbox
      v-model="alwaysAcceptAVV"
      color="primary"
      class="avv_checkbox"
      :class="hideTitle ? 'mt-0' : ''"
      :error-messages="checkbox($v.alwaysAcceptAVV, $v)"
      @change="changeEvent($event)"
      @blur="changeEvent($event)"
    ><template #label
    ><div class="pl-8">
      {{ $t('component.profile.accountManagement.avv') }}<br />
      <a href="/avv" target="_blank" @click.stop>
        {{ $t('component.profile.accountManagement.avv.hyperlink') }}</a>
    </div>
    </template>
    </v-checkbox>

    <v-btn
      v-if="!hideSubmit"
      :disabled="$v.alwaysAcceptAVV.$invalid"
      :loading="loading"
      color="primary"
      class="mt-2"
      @click="submitAVV">
      {{ $t('button.avv.accept') }}</v-btn>
  </div>
</template>
<style lang="scss" scoped>
.avv_checkbox {
  .v-input--selection-controls__input {
    top: 0;
    bottom: 0;
  }
}
</style>
